// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainDialog {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  min-width: 320px;
}
.mainDialog .header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/components/ResutTest/JobGroups/PriorityBox/InfoKnowledge/confirm.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACR","sourcesContent":[".mainDialog {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    min-width: 320px;\n\n    .header {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
